import * as CONST from '../ActionTypes';

const initialState = {
  customerList: [],
  allCustomerList: [],
  csvCustomerList: [],
  customer: {},
  searchParams: {
    customerName: '',
    companyName: '',
    email: '',
    phoneNumber: '',
    createdAtFrom: '',
    createdAtTo: '',
    prefectureId: '',
    gender: '',
    birthDateFrom: '',
    birthDateTo: '',
    birthMonth: '',
    withdrewScheduledAtFrom: '',
    withdrewScheduledAtTo: '',
  },
  sortParams: {
    createdAtAsc: true,
    idAsc: true,
    prefAsc: true,
    nameKanaAsc: true,
    birthdateAsc: true,
  },
  isSuccess: false,
  isFailure: false,
  errorMessage: '',
  isSuccessMail: false,
  isFailureMail: false,
  errorMessageMail: '',
  query: {
    customerName: '',
    firstName: '',
    familyName: '',
    companyName: '',
    email: '',
    phoneNumber: '',
    createdAtFrom: '',
    createdAtTo: '',
    prefectureId: '',
    gender: '',
    birthDateFrom: '',
    birthDateTo: '',
    birthMonth: '',
    sort: 'created_at',
    isAsc: false,
    currentPage: 0,
    itemsPerPage: 10,
    free1: '',
    free2: '',
    free3: '',
    free4: '',
    free5: '',
    free6: '',
    free7: '',
    free8: '',
    free9: '',
    free10: '',
    free11: '',
    free12: '',
    free13: '',
    free14: '',
    free15: '',
    free16: '',
    idFrom: '',
    idTo: '',
    withdrewScheduledAtFrom: '',
    withdrewScheduledAtTo: '',
  },
};

function custoemr(state = initialState, action) {
  switch (action.type) {
    // -----------------
    // 顧客一覧取得
    // -----------------
    case CONST.GET_CUSTOMER_LIST_SUCCESS:
      return Object.assign(
        {},
        state,
        {
          customerList: action.payload,
        },
      );
    case CONST.GET_CUSTOMER_LIST_FAILURE:
      return Object.assign(
        {},
        state,
        {
          customerList: [],
        },
      );
    // -----------------
    // 顧客全件取得
    // -----------------
    case CONST.GET_ALL_CUSTOMER_LIST_SUCCESS:
      return Object.assign(
        {},
        state,
        {
          allCustomerList: action.payload,
        },
      );
    case CONST.GET_ALL_CUSTOMER_LIST_FAILURE:
      return Object.assign(
        {},
        state,
        {
          allCustomerList: [],
        },
      );
    // -----------------
    // 顧客一覧取得(CSV用)
    // -----------------
    case CONST.GET_CSV_CUSTOMER_LIST_SUCCESS:
      return Object.assign(
        {},
        state,
        {
          csvCustomerList: action.payload,
        },
      );
    case CONST.GET_CSV_CUSTOMER_LIST_FAILURE:
      return Object.assign(
        {},
        state,
        {
          csvCustomerList: [],
        },
      );
    // -----------------
    // 顧客詳細取得
    // -----------------
    case CONST.GET_CUSTOMER_DETAIL_SUCCESS:
      return Object.assign(
        {},
        state,
        {
          customer: action.payload,
        },
      );
    case CONST.GET_CUSTOMER_DETAIL_FAILURE:
      return Object.assign(
        {},
        state,
        {
          customer: {},
        },
      );
    // -----------------
    // 検索パラメーターセット
    // -----------------
    case CONST.SET_CUSTOMER_SEARCH_PARAMS:
      return Object.assign(
        {},
        state,
        action.payload,
      );
    // -----------------
    // 検索パラメーターリセット
    // -----------------
    case CONST.CLEAR_CUSTOMER_SEARCH_PARAMS:
      return Object.assign(
        {},
        state,
        {
          searchParams: {
            customerName: '',
            companyName: '',
            email: '',
            phoneNumber: '',
            createdAtFrom: '',
            createdAtTo: '',
            prefectureId: '',
            gender: '',
            birthDateFrom: '',
            birthDateTo: '',
            birthMonth: '',
            withdrewScheduledAtFrom: '',
            withdrewScheduledAtTo: '',
          },
          sortParams: {
            createdAtAsc: true,
            idAsc: true,
            prefAsc: true,
            nameKanaAsc: true,
            birthdateAsc: true,
          },
        },
      );
    // -----------------
    // 顧客削除
    // -----------------
    case CONST.DELETE_CUSTOMER_SUCCESS:
      return Object.assign(
        {},
        state,
        {
          isSuccess: true,
          isFailure: false,
          errorMessage: '',
        },
      );
    case CONST.DELETE_CUSTOMER_FAILURE:
      return Object.assign(
        {},
        state,
        {
          isSuccess: false,
          isFailure: true,
          errorMessage: action.payload,
        },
      );
    // -----------------
    // 結果フラグクリア
    // -----------------
    case CONST.CLEAR_DELETE_CUSTOMER_RESULT_FLG:
      return Object.assign(
        {},
        state,
        {
          isSuccess: false,
          isFailure: false,
          errorMessage: '',
        },
      );
    // -----------------
    // 顧客にメール送信
    // -----------------
    case CONST.SEND_MAIL_CUSTOMER_SUCCESS:
      return Object.assign(
        {},
        state,
        {
          isSuccessMail: true,
          isFailureMail: false,
          errorMessageMail: '',
        },
      );
    case CONST.SEND_MAIL_CUSTOMER_FAILURE:
      return Object.assign(
        {},
        state,
        {
          isSuccessMail: false,
          isFailureMail: true,
          errorMessageMail: action.payload,
        },
      );
    // -----------------
    // メール送信結果フラグクリア
    // -----------------
    case CONST.CLEAR_SEND_MAIL_CUSTOMER_RESULT_FLG:
      return Object.assign(
        {},
        state,
        {
          isSuccessMail: false,
          isFailureMail: false,
          errorMessageMail: '',
        },
      );
    // -----------------
    // queryパラメータの設定
    // -----------------
    case CONST.SET_CUSTOMER_QUERY:
      return Object.assign(
        {},
        state,
        {
          query: Object.assign(
            {},
            state,
            action.payload,
          ),
        },
      );
    // -----------------
    // queryパラメータのクリア
    // -----------------
    case CONST.CLEAR_CUSTOMER_QUERY:
      return Object.assign(
        {},
        state,
        {
          query: {
            customerName: '',
            companyName: '',
            email: '',
            phoneNumber: '',
            createdAtFrom: '',
            createdAtTo: '',
            prefectureId: '',
            gender: '',
            birthDateFrom: '',
            birthDateTo: '',
            birthMonth: '',
            withdrewScheduledAtFrom: '',
            withdrewScheduledAtTo: '',
            sort: 'created_at',
            isAsc: false,
            currentPage: 0,
            itemsPerPage: 10,
          },
        },
      );
    // -----------------
    // CSVで顧客を登録
    // -----------------
    case CONST.CREATE_CUSTOMER_BY_CSV_FAILURE:
      return Object.assign(
        {},
        state,
        {
          errorMessage: action.payload,
        },
      );
    case CONST.CLEAR_CREATE_CUSTOMER_BY_CSV_RESULT:
      return Object.assign(
        {},
        state,
        {
          errorMessage: '',
        },
      );
    default:
      return state;
  }
}

export default custoemr;
